import React from "react";
import TermsAndCondition from "../components/TermsAndCondition";
import BreadcrumbTwo from "../components/BreadcrumbTwo";

const TermsAndConditionsPage = () => {
  return (
    <>
      <BreadcrumbTwo title="Terms & Conditions" />
      <TermsAndCondition />
    </>
  );
};

export default TermsAndConditionsPage;